import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
export function SdkRiskPage() {
  return <DocPageLayout title="Risk SDK" description="Client-side risk data collection for enhanced fraud detection." breadcrumbs={[{
    label: 'API Reference',
    id: 'api-overview'
  }, {
    label: 'SDKs'
  }, {
    label: 'Risk'
  }]} data-id="element-843">
      <p className="text-gray-700 mb-8" data-id="element-844">
        The Risk SDK collects device fingerprint and behavioral data from the
        payer's browser to enhance fraud detection accuracy. This data is sent
        to the gateway alongside the transaction for risk assessment.
      </p>
      <h2 className="text-2xl font-bold text-gray-900 mt-6 mb-4" data-id="element-845">
        Installation
      </h2>
      <CodeBlock language="HTML" title="Script Include" code={`<script src="https://test-gateway.mastercard.com/static/risk/v1/risk.js"></script>`} data-id="element-846" />
      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-847">Usage</h2>
      <CodeBlock language="JavaScript" title="Risk Data Collection" code={`Risk.configure({
  merchantId: "YOUR_MERCHANT_ID",
  sessionId: "SESSION_ID",
  callbacks: {
    onCollected: function(data) {
      console.log("Risk data collected:", data.correlationId);
      // Include correlationId in your payment request
    },
    onError: function(error) {
      console.error("Risk collection failed:", error);
    }
  }
});

// Trigger data collection
Risk.collect();`} data-id="element-848" />
      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-849">
        Collected Data Points
      </h2>
      <div className="overflow-x-auto mb-8" data-id="element-850">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-851">
          <thead data-id="element-852">
            <tr className="bg-gray-100" data-id="element-853">
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-854">
                Data Point
              </th>
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-855">
                Description
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-856">
            <tr data-id="element-857">
              <td className="px-4 py-3" data-id="element-858">Device fingerprint</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-859">
                Browser, OS, screen resolution, timezone
              </td>
            </tr>
            <tr className="bg-gray-50" data-id="element-860">
              <td className="px-4 py-3" data-id="element-861">IP geolocation</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-862">
                Approximate location based on IP address
              </td>
            </tr>
            <tr data-id="element-863">
              <td className="px-4 py-3" data-id="element-864">Behavioral signals</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-865">
                Mouse movement, typing patterns, session duration
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DocPageLayout>;
}